import { MonitoringMessageOptions } from './monitoring.interface';

/** Levels routed to error tracking (RUM addError / APM span error) rather than logs. */
export const isErrorLevel = (level: MonitoringMessageOptions['level']): boolean =>
  level === 'error' || level === 'warning' || level === 'fatal';

export const IGNORED_ERROR_PATTERNS: Array<string | RegExp> = [
  '[object Object]',
  'Navigator.geolocation fetch failed',
  "Failed to execute 'sendBeacon' on 'Navigator': Refused to send beacon",
  /(?=.*QuotaExceededError)(?=.*snapinsPage_).*/, // Caused by Fluido/Salesforce chat and flooding from bots
];

// Allows any finnair.com host (www + internal env hosts like ux-lambda-feat-*.fcom.dev.app.finnair.com)
// so RUM/Sentry report from feature and non-prod environments too. Parses the real hostname rather
// than pattern-matching the string, so look-alikes (finnair.com.evil.com, evilfinnair.com,
// https://finnair.com@evil.com) cannot spoof it.
export const isFinnairMonitoringUrl = (url: string): boolean => {
  try {
    const { hostname } = new URL(url);
    return hostname === 'finnair.com' || hostname.endsWith('.finnair.com');
  } catch {
    return false;
  }
};

export const maskSensitive = (value: string): string =>
  value.replace(/(hash|cartId|orderId)=(\w+(==)?)/g, '$1=********');

export const isIgnoredErrorMessage = (message: string | undefined): boolean =>
  !!message &&
  IGNORED_ERROR_PATTERNS.some((pattern) =>
    typeof pattern === 'string' ? message.includes(pattern) : pattern.test(message)
  );
